import React from 'react';
import './index.scss';

export default function OrderFilters() {
    return(
        <p>Order Filters Page is Working</p>
    );
}